import React from 'react';
import './ampol-cash-card-details.scss';
import CardImageLookup from '../../../../components/card-image-lookup/card-image-lookup';
import dayjs from 'dayjs';
import { switchExpiryDate } from 'utilities/card-utilities';
import { useSelector } from 'react-redux';

/**
 * Ampol Cash Card Details
 * @returns JSX Element
 */
const AmpolCashCardDetails = ({ orderCardDetails }) => {
  const cardDetails = useSelector((state) => state.cashStore.cashCardDetails);

  return <>
    <div className='ampol-cash-card-details__top-row-container'>
      <div className='ampol-cash-card-details__grid-cell ampol-cash-card-details__grid-cell--image'>
        <CardImageLookup isLarge={true} isDigital={orderCardDetails?.mediaTypeCode === 'D'} plasticTypeId={cardDetails?.plasticTypeCode} />
      </div>
      <div className='ampol-cash-card-details__grid-cell'>
        <span>Card number</span>
        <span className='ampol-cash-card-details__card-number'>{orderCardDetails?.cardNumber}</span>
      </div>
    </div>
    <div className='ampol-cash-card-details__second-row-container'>
      <div className='ampol-cash-card-details__grid-cell'>
        <h1 className='ampol-cash-card-details__title'>{orderCardDetails?.ampolCashDenomination}</h1>
        <span className='ampol-cash-card-details__content'>{orderCardDetails?.mediaType} {cardDetails?.isFuelOnly && '| Fuel only '} {(cardDetails?.pinControlVerificationType && cardDetails?.pinControlVerificationType !== 'None') && '| PIN required '}</span>
      </div>
      <div className='ampol-cash-card-details__grid-cell'>
        <h1 className='ampol-cash-card-details__title'>Recipient details</h1>
        <span className='ampol-cash-card-details__content'>{cardDetails?.address?.firstName} {cardDetails?.address?.lastName}</span>
        {cardDetails?.mediaType === 'Physical'
          ? <>
            <span className='ampol-cash-card-details__content'>{cardDetails?.address?.line1}</span>
            <span className='ampol-cash-card-details__content'>{cardDetails?.address?.line2}</span>
            <span className='ampol-cash-card-details__content'>{cardDetails?.address?.city}</span>
            <span className='ampol-cash-card-details__content'>{cardDetails?.address?.stateCode} {cardDetails?.address?.postCode}</span>
          </>
          : <span className='ampol-cash-card-details__content'>{cardDetails?.address?.email}</span>
        }
      </div>
      <div className='ampol-cash-card-details__grid-cell'>
        <h1 className='ampol-cash-card-details__title'>Dispatch date</h1>
        <span className='ampol-cash-card-details__content'>{cardDetails?.dispatchDate}</span>
      </div>
      <div className='ampol-cash-card-details__grid-cell'>
        <h1 className='ampol-cash-card-details__title'>Expiry date (MM/YYYY)</h1>
        <span className='ampol-cash-card-details__content'>{cardDetails?.expiryDate ? dayjs(switchExpiryDate(cardDetails.expiryDate), 'MM/YY').format('MM/YYYY') : ''}</span>
      </div>
      <div className='ampol-cash-card-details__grid-cell'>
        <h1 className='ampol-cash-card-details__title'>Tracking Number</h1>
        <span className='ampol-cash-card-details__content'>{cardDetails?.trackingNumber}</span>
      </div>
    </div>
    {cardDetails?.mediaTypeCode === 'D' &&
      <div>
        <h1 className='ampol-cash-card-details__title'>Message</h1>
        <span className='ampol-cash-card-details__content'>{cardDetails?.address?.addInfo}</span>
      </div>
    }
  </>;
};

export default AmpolCashCardDetails;
